import React from 'react';
import { FormattedMessage } from 'react-intl';

export const FLEETBACK_API_ERROR = {
  NOT_FOUND: 'Not Found'
};

export const END_REQUEST = 'REQUEST';

export const SUCCESS_REQUEST = 'SUCCESS';

export const FAILURE_REQUEST = 'FAILURE';

export const DEFAULT_FAILURE_MESSAGE = {
  id: 'http.error.message',
  defaultMessage: 'Oops! Something went wrong.'
};

export const ENTITY_TYPE = {
  APPOINTMENT_TASK: 'APPOINTMENT_TASK',
  AUDIT: 'AUDIT',
  AUDIT_MODEL: 'AUDIT_MODEL',
  CAMPAIGN: 'CAMPAIGN',
  CAMPAIGN_FILE: 'CAMPAIGN_FILE',
  CAMERA_OFFICE: 'CAMERA_OFFICE',
  CHECKLIST_CAMPAIGN: 'CHECKLIST_CAMPAIGN',
  CHECKLIST_INTERVENTION: 'CHECKLIST_INTERVENTION',
  CHECKLIST_PARTS_INTERVENTION: 'CHECKLIST_PARTS_INTERVENTION',
  CHECKLIST_SELF_SERVICE: 'CHECKLIST_SELF_SERVICE',
  CHECKLIST: 'CHECKLIST',
  CONVERSATION: 'CONVERSATION',
  DEALER: 'DEALER',
  FOLLOW_UP: 'FOLLOW_UP',
  GUIDELINE: 'GUIDELINE',
  CONTACT_LIST: 'CONTACT_LIST',
  INTERVENTION: 'INTERVENTION',
  KIOSK: 'KIOSK',
  MESSAGE: 'MESSAGE',
  MESSAGE_REACTION: 'MESSAGE_REACTION',
  MOBILITY: 'MOBILITY',
  PARTS_INTERVENTION: 'PARTS_INTERVENTION',
  QUESTION_FORM_MODEL: 'QUESTION_FORM_MODEL',
  QUESTION_FORM: 'QUESTION_FORM',
  RELEASE_MOBILE: 'RELEASE_MOBILE',
  RELEASE_WEB: 'RELEASE_WEB',
  SCREENSAVER: 'SCREENSAVER',
  SELF_SERVICE: 'SELF_SERVICE',
  TIRE: 'TIRE',
  VEHICLE_CHECK_MODEL: 'VEHICLE_CHECK_MODEL',
  MEDIA_LIBRARY: 'MEDIA_LIBRARY',
  KIOSK_STATUS: 'KIOSK_STATUS',
  GROUP: 'GROUP',
  HELPDESK: 'HELPDESK',
  GATE: 'GATE'
};

export const ENTITY_ORIGIN = {
  DEALER: 'DEALER',
  GROUP: 'GROUP'
};

export const DEFAULT_THEME = 'DEFAULT';

export const THEME_LABEL = {
  [DEFAULT_THEME]: <FormattedMessage id="default" defaultMessage="Default" />
};
